import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ArrowUpRight, Handshake, LayoutDashboard, LogOut, ShieldAlert } from "lucide-react";

export default function ResellerLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const links = [
    { to: "/reseller", label: "Visão geral", icon: LayoutDashboard, end: true },
  ];

  return (
    <div className="min-h-[100dvh] bg-[#090b0a] text-zinc-100 lg:flex">
      <aside className="border-b border-white/10 bg-[#0d100f] lg:flex lg:w-64 lg:shrink-0 lg:flex-col lg:border-b-0 lg:border-r">
        <div className="flex items-center justify-between border-b border-white/10 px-5 py-4 lg:block lg:px-6 lg:py-6">
          <Link to="/" className="flex items-center gap-3" aria-label="Flix VPS — início">
            <span className="flex h-9 w-9 items-center justify-center border border-emerald-300/50 bg-emerald-300 text-[#07100b]">
              <ShieldAlert className="h-4 w-4" strokeWidth={2.2} />
            </span>
            <span>
              <span className="block font-heading text-base font-black tracking-tight">Flix VPS</span>
              <span className="block font-mono text-[9px] uppercase tracking-[0.2em] text-zinc-500">Parceiros</span>
            </span>
          </Link>
          <span className="hidden font-mono text-[10px] uppercase tracking-[0.16em] text-emerald-300/80 lg:mt-7 lg:block">Área do parceiro</span>
          <Handshake className="h-5 w-5 text-emerald-300 lg:hidden" aria-hidden="true" />
        </div>

        <nav aria-label="Navegação do parceiro" className="flex gap-1 overflow-x-auto px-3 py-2 lg:flex-1 lg:flex-col lg:gap-1 lg:overflow-visible lg:px-3 lg:py-5">
          {links.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex shrink-0 items-center gap-3 border px-3 py-2.5 text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 ${
                  isActive
                    ? "border-emerald-300/30 bg-emerald-300 text-[#08100b]"
                    : "border-transparent text-zinc-400 hover:border-white/10 hover:bg-white/[0.035] hover:text-zinc-100"
                }`
              }
            >
              <Icon className="h-4 w-4" aria-hidden="true" />
              {label}
            </NavLink>
          ))}
          <a href="mailto:suporte@flixvps.com.br" className="flex shrink-0 items-center gap-3 border border-transparent px-3 py-2.5 text-sm text-zinc-500 transition-colors hover:text-zinc-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300">
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
            Falar com suporte
          </a>
        </nav>

        <div className="border-t border-white/10 p-2 lg:hidden">
          <Button
            variant="ghost"
            className="w-full justify-start rounded-none text-zinc-400 hover:bg-white/5 hover:text-white"
            onClick={async () => { await logout(); navigate("/"); }}
            aria-label="Sair da conta"
          >
            <LogOut className="mr-2 h-4 w-4" /> Sair
          </Button>
        </div>

        <div className="hidden border-t border-white/10 p-3 lg:block">
          <div className="mb-2 px-3 py-2">
            <div className="truncate text-sm font-medium">{user?.name || "Parceiro"}</div>
            <div className="truncate font-mono text-[11px] text-zinc-500">{user?.email || ""}</div>
          </div>
          <Button
            variant="ghost"
            className="w-full justify-start rounded-none text-zinc-400 hover:bg-white/5 hover:text-white"
            onClick={async () => { await logout(); navigate("/"); }}
            aria-label="Sair da conta"
          >
            <LogOut className="mr-2 h-4 w-4" /> Sair
          </Button>
        </div>
      </aside>

      <main className="min-w-0 flex-1">
        <div className="mx-auto w-full max-w-[1440px] p-4 sm:p-6 lg:p-9">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
